import React from 'react';
import { CreateUserForm } from 'shared/ui';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { validateCreateManagerForm } from '../model/validate-create-manager-form';
import { BusinessApi } from 'shared/api';

interface IProps {
  businessId: string;
}

export const CreateManagerForm: React.FC<IProps> = ({ businessId }) => {
  return (
    <CreateUserForm
      title="Регистрация менеджера"
      fioLabel="ФИО менеджера"
      buttonText="Зарегистрировать менеджера"
      businessId={businessId}
      navigateLink={AppLinks.BusinessLink.replace(':id', businessId)}
      successMessage="Менеджер успешно создан"
      onSubmit={async (data) => {
        await BusinessApi.createManager({
          email: data.email,
          fio: data.fio.trim(),
          phone: data.phone,
          password: data.password,
          businessId,
          pointIds: data.pointIds,
        });
      }}
      validate={(data) =>
        validateCreateManagerForm({
          fio: data.fio,
          email: data.email,
          phone: data.phone,
          password: data.password,
          confirmPassword: data.confirmPassword,
        })
      }
    />
  );
};
